import React, { Component }        from 'react';
import { connect }                 from 'react-redux';
import { Field, reduxForm, reset } from 'redux-form';
import { Redirect,Link }           from 'react-router-dom';
import Lightbox                    from 'react-images';
import renderFieldTextArea         from '../../../../container/renderFieldTextArea';
import renderField                 from '../../../../container/renderField';
import renderFieldSelect           from '../../../../container/renderFieldSelect';
import renderFiles                 from '../../../../container/renderFiles';
import validate                    from '../../../../service/validade_missoes';
import { SetCrudsQuestao,
         ExcluirImagemQuestao}     from '../../../../actions/atividadesAction';
import { SetError }                from '../../../../actions/notificacaoAction';
import { ActionModal,
    GetListaMenuTopo,
    GetListaSubMenuTopo}           from '../../../../actions/scopoAction';

class QuizForm extends Component {

    constructor(props){
        super(props);
        this.state = {
                      ati_que_id       : 0,
                      que_id           : (this.props.que_id?this.props.que_id:[this.props.match.params.id1]),
                      textButton       : 'Adicionar',
                      valMax           : 180,
                      countDinamic     : 180,
                      valMaxCont       : 350,
                      countDinamicCont : 350,
                      files            : false,
                      lightboxIsOpen   : false,
                      redirect : false,
                     }

    }

    componentWillMount(){
        
        if(!this.props.que_id){
            if(this.props.match.params.id2>0) {
                this.acaoForm(true);
            }
        }

       this.props.GetListaMenuTopo([
        {action:true,nome:"Home",link:this.props.menu.home},
        {action:true,nome:this.props.menu.desafios.nomeModulo,link:this.props.menu.desafios.home},
        {action:true,nome:this.props.menu.desafios.jogo.jogo3,link:`${this.props.menu.desafios.desafioquiz}/${this.state.que_id[0]}`}
       ]);
       this.props.GetListaSubMenuTopo([]);
    }

    loadListUpload(files){
        const retFiles =  files.map((elem,i) =>{
            return <div className="uploadFileSelect" key={i}>
                        <span className="pull-left">{elem.name} ({elem.size})</span>
                        <span className="pull-right">
                            <button onClick={this.resetUpload.bind(this,i)} className="btn btn-danger btn-xs">x</button>
                        </span>
                    </div>;
        });
        this.setState({selectUpload:1, files: files,selectFiles:retFiles});
    }

    excluirImagem(id){
   
         this.props.ExcluirImagemQuestao(id).then((response)=>{
            this.setState({anexo_imagem:""})
         }).catch((error)=>{
            this.props.SetError(500);
         });
    }
        
    onDrop(files) {
       this.loadListUpload(files);
    }
           
    resetUpload(val){
        Array.prototype.remove = function(start, end) {
            this.splice(start, end);
            return this;
        }
        this.state.files.remove(val, 1);
        this.loadListUpload(this.state.files)
    }
    
    acaoForm(acao){
          
        const dados = this.props.all_questao;
        const retorno = dados.filter(elem =>{  return elem.ati_que_id == this.props.match.params.id2 });
      
        this.props.initialize({
            ati_que_id       : (acao?retorno[0].ati_que_id:0),
            ati_ati_per      : (acao?retorno[0].ati_que_pergunta:""),
            ati_questao_a    : (acao?retorno[0].ati_que_opcao_a:""),
            ati_questao_b    : (acao?retorno[0].ati_que_opcao_b:""),
            ati_questao_c    : (acao?retorno[0].ati_que_opcao_c:""),
            ati_questao_d    : (acao?retorno[0].ati_que_opcao_d:""),
            ati_resposta     : (acao?retorno[0].ati_que_resposta:""),
            ati_que_contexto : (acao?retorno[0].ati_que_contexto:""),
            ati_que_tempo    : (acao?retorno[0].ati_que_tempo:"")
        });

        this.setState({
                        ati_que_id       : retorno[0].ati_que_id,
                        textButton       : 'Editar',
                        anexo_imagem     : retorno[0].ati_que_anexo,
                        countDinamic     : this.state.valMax-retorno[0].ati_que_pergunta.length,
                        countDinamicCont : this.state.valMaxCont-retorno[0].ati_que_contexto.length
                    })
    }

    handleSubmit(e){
        const form = {
                      ati_ati_per      : e.ati_ati_per,
                      ati_questao_a    : e.ati_questao_a,
                      ati_questao_b    : e.ati_questao_b,
                      ati_questao_c    : e.ati_questao_c,
                      ati_questao_d    : e.ati_questao_d,
                      ati_resposta     : e.ati_resposta,
                      ati_que_tempo    : e.ati_que_tempo,
                      ati_que_contexto : e.ati_que_contexto,
                      ati_que_id       : this.state.ati_que_id,
                      que_id           : this.state.que_id
                    }
      
        this.setState({textButton:'Enviando...'})            
        this.props.SetCrudsQuestao(form,this.state.files).then((response)=>{          
            alert('Ação realizada com sucesso!'); 
            this.setState({textButton:'Adicionar',files:false,selectFiles:"",countDinamic: this.state.valMax,countDinamicCont: this.state.valMaxCont});
            if(!this.props.que_id){
              if(this.props.match.params.id2>0){
                this.setState({redirect:true});
              }
            }
        }).catch((error)=>{
            this.props.SetError(500);
        })
    }

    closeLightbox(){        
      this.setState({lightboxIsOpen:false});
    }
        
    openImg(){
      this.setState({lightboxIsOpen:true});
    }

    countCaractere(e){
     const text_remaning = this.state.valMax - e.target.textLength;
      this.setState({countDinamic:text_remaning});
    }

    countCaractereContexto(e){
       const text_remaning = this.state.valMaxCont - e.target.textLength;
       this.setState({countDinamicCont:text_remaning});
    }

    render() {

        if (this.state.redirect) {
            return (<Redirect to={`${this.props.menu.desafios.desafioquiz}/${this.state.que_id[0]}`}/>);
        }  

        const {handleSubmit} = this.props;
        const listaresposta  = [{item:'Alternativa: A',value:'a'},{item:'Alternativa: B',value:'b'},{item:'Alternativa: C',value:'c'},{item:'Alternativa: D',value:'d'}];
        const listresposta   = listaresposta.map((elem,i)  => <option key={i} value={elem.value}>{elem.item}</option>);
        const listTempo      = [{item:30},{item:60},{item:90},{item:120}].map((elem,i)  => <option key={i} value={elem.value}>{elem.item}</option>);
        return (
          <div className="container-bg">
          <div className="panel panel-default">
              <div className="panel-body">
                  <form onSubmit={handleSubmit(this.handleSubmit.bind(this))}>
                      <div className="conteudo-pergunta">
                      <span className="count pull-right">{this.state.countDinamicCont && this.state.countDinamicCont}</span>
                          <Field name="ati_que_contexto" type="textarea" onChange={this.countCaractereContexto.bind(this)} length={this.state.valMaxCont} component={renderFieldTextArea} label="Contexto" />
                        
                      </div>
                      <div className="conteudo-pergunta">
                      <span className="count pull-right">{this.state.countDinamic && this.state.countDinamic}</span>
                          <Field name="ati_ati_per" type="textarea" onChange={this.countCaractere.bind(this)} length={this.state.valMax} component={renderFieldTextArea} label="Pergunta" />
                         
                      </div>
                      <div className="row">
                          <div className="col-md-6"><Field name="ati_questao_a" type="text" length="40" component={renderField} label="Opção A"/></div>
                          <div className="col-md-6"><Field name="ati_questao_b" type="text" length="40" component={renderField} label="Opção B"/></div>
                      </div>

                      <div className="row">
                          <div className="col-md-6"><Field name="ati_questao_c" type="text" length="40" component={renderField} label="Opção C"/></div>
                          <div className="col-md-6"><Field name="ati_questao_d" type="text" length="40" component={renderField} label="Opção D"/></div>
                      </div>
                     
                      <div className="row">
                          <div className="col-md-6">
                              <Field name="ati_resposta" label="Quantidade de Tentativa" component={renderFieldSelect} option={listresposta}/>
                          </div>
                          <div className="col-md-6">
                              <Field name="ati_que_tempo" label="Tempo" component={renderFieldSelect} option={listTempo}/>
                          </div>
                      </div>
      
                      <p>{this.state.anexo_imagem ?
                          <div className="panel panel-default panel-imagem-questao-missao">
                              <div className="panel-body">
                                  <a href={void(0)} onClick={this.openImg.bind(this)}>
                                      <img alt="" className="img-rounded pull-center img-responsive" width="200" src={this.state.anexo_imagem}/>
                                      <Lightbox images={[{ src: this.state.anexo_imagem }]} isOpen={this.state.lightboxIsOpen} onClose={ this.closeLightbox.bind(this)}/>
                                  </a>
                              </div>
                              <a href={void(0)} onClick={this.excluirImagem.bind(this,this.state.ati_que_id)} className="pull-right">Excluir</a>
                          </div>:""}
                      </p>
                      <div className="form-group">
                          <Field 
                            label     = "Selecione uma imagem. (Opcional)" 
                            textField = "Arquivo" 
                            component = {renderFiles} 
                            name      = "ati_file" 
                            accept    = "image/jpeg, image/png, image/gif" 
                            funcao    = {this.onDrop.bind(this)}/>
                      </div>
                      {this.state.selectFiles} 
                      
                      <Link  to={`${this.props.menu.desafios.desafioquiz}/${this.state.que_id[0]}`} className="btn btn-sm btn-primary pull-left">Voltar</Link>
                      <button type="submit" className="btn btn-primary btn-sm pull-right">{this.state.textButton}</button>
                  </form>
              </div>
          </div>
      
      </div>
        );
    }
}

const afterSubmit = (result, dispatch) => dispatch(reset('quiz_form'));

function mapStateToProps(state){
    
        return {
          menu : state.configReducer.menu,
          all_questao : state.atividadesReducer.fetch_all_questao
        }
    }

export default reduxForm({
        form                     : 'quiz_form',
        destroyOnUnmount         : true,
        forceUnregisterOnUnmount : true,
        onSubmitSuccess          : afterSubmit,
        validate
      })(connect(mapStateToProps,{SetCrudsQuestao,
                                  ExcluirImagemQuestao,
                                  ActionModal,
                                  GetListaMenuTopo,
                                  GetListaSubMenuTopo,
                                  SetError})(QuizForm));




// WEBPACK FOOTER //
// ./src/components/professor/desafios/quiz/desafios_quiz_form.js